import Axios from '@/utils/axios';
import { getBackendErrorMessage } from '@/utils/errorHandler';

export type PurchaseOrderApproverLayer = 'LAYER_1' | 'COO';

export interface PurchaseOrderApprover {
  id: number;
  email: string;
  layer: PurchaseOrderApproverLayer;
  isActive: boolean;
  createdAt: string;
}

export interface GetPurchaseOrderApproversParams {
  layer?: PurchaseOrderApproverLayer;
  page?: string;
  size?: string;
  search?: string;
}

// Backend-enforced allowlist of who may approve a PO, by layer. The FE uses it
// only to show/hide the action buttons (UX); the real gate is server-side.
export const getPurchaseOrderApprovers = async (
  params: GetPurchaseOrderApproversParams = {}
): Promise<PurchaseOrderApprover[]> => {
  try {
    const response = await Axios.get('/v1/purchase-order-approvers', {
      params: { size: '1000', ...params },
    });
    return response.data?.data || [];
  } catch (error) {
    throw new Error(getBackendErrorMessage(error));
  }
};
